const theme: 'light' = 'light';

interface IColors {
  azulClaro: string;
  azulEscuro: string;
  cinzaEscuro: string;
  cinzaClaro: string;
  branco: string;
  vermelho: string;
  verde: string;
}

export const getColors = (): IColors => {
  return {
    azulClaro: '#BE638D ',
    azulEscuro: '#423B7D ',
    cinzaEscuro: '#616161',
    cinzaClaro: '#f1f1f166',
    branco: '#ffffff',
    vermelho: '#B85151',
    verde: '#759162',
  };
};
